import React from "react";
export var SoundDownloadContext = React.createContext([]);
export var SoundDownloadontextProvider = SoundDownloadContext.Provider;
export var SoundDownloadContextConsumer = SoundDownloadContext.Consumer;
//# sourceMappingURL=sounddownload.js.map